module.exports = __webpack_public_path__ + "img/authority-setting.5ec8e7a1.svg";